import { useState } from "react";
import { api, ROUTES } from "./api";
import { useAdmin, useAsync, ImageInput, ErrorState, Loading, PageHead } from "./ui";

export default function HeaderInfo() {
  const { data, loading, error, reload } = useAsync(() => api.get(ROUTES.headerInfo));
  if (error) return <ErrorState error={error} onRetry={reload} />;
  if (loading || !data) return <Loading />;
  return <HeaderForm initial={data} onSaved={reload} />;
}

function HeaderForm({ initial, onSaved }) {
  const { toast } = useAdmin();
  const [links, setLinks] = useState(initial.navLinks || []);
  const [logoFile, setLogoFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const update = (i, k, v) =>
    setLinks((l) => l.map((it, x) => (x === i ? { ...it, [k]: v } : it)));

  const move = (i, dir) =>
    setLinks((l) => {
      const j = i + dir;
      if (j < 0 || j >= l.length) return l;
      const copy = [...l];
      [copy[i], copy[j]] = [copy[j], copy[i]];
      return copy;
    });

  const submit = async (e) => {
    e.preventDefault();
    const clean = links
      .map((l) => ({ label: l.label.trim(), to: l.to.trim() }))
      .filter((l) => l.label && l.to);
    setSaving(true);
    try {
      const form = new FormData();
      form.append("data", JSON.stringify({ navLinks: clean }));
      if (logoFile) form.append("logo", logoFile);
      await api.upload("PUT", ROUTES.headerInfo, form);
      toast("Header saved");
      setLogoFile(null);
      onSaved();
    } catch (err) {
      toast(err.message, "err");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <PageHead
        title="Header"
        sub="Edit the logo and the menu links shown at the top of the site"
        actions={<button className="btn primary" form="header-form" disabled={saving}>{saving ? "Saving…" : "Save changes"}</button>}
      />
      <form id="header-form" onSubmit={submit} className="form-grid">
        <div className="span-2">
          <span className="field-label">Logo</span>
          <ImageInput current={initial.logo} file={logoFile} onChange={setLogoFile} />
        </div>

        <div className="span-2">
          <span className="field-label">Menu links</span>
          {links.map((it, i) => (
            <div key={i} style={{ display: "flex", gap: 8, margin: "8px 0", alignItems: "center" }}>
              <input className="input" style={{ flex: 1 }} value={it.label} placeholder="Name (e.g. Shop)" onChange={(e) => update(i, "label", e.target.value)} />
              <input className="input" style={{ flex: 1 }} value={it.to} placeholder="Link (e.g. /shop)" onChange={(e) => update(i, "to", e.target.value)} />
              <button type="button" className="btn sm" onClick={() => move(i, -1)} disabled={i === 0}>↑</button>
              <button type="button" className="btn sm" onClick={() => move(i, 1)} disabled={i === links.length - 1}>↓</button>
              <button type="button" className="btn sm danger-ghost" onClick={() => setLinks((l) => l.filter((_, x) => x !== i))}>Remove</button>
            </div>
          ))}
          <button type="button" className="btn sm" onClick={() => setLinks((l) => [...l, { label: "", to: "" }])}>
            Add link
          </button>
        </div>
      </form>
    </>
  );
}